module.exports = __webpack_public_path__ + "img/v_president.7858e40f.png";